import React, { useMemo } from 'react'
import { gql, useQuery } from '@apollo/client'

import { Query } from 'graphqlAPI'
import { ChildFilterTypes } from 'enum'
import { ApplyFiltersByType } from '../types'
import { GeneralProgress } from './GeneralProgress'

const GLOBAL_ADVANCEMENT = gql`
  query GlobalAdvancement($usersAllCourseRansack: JSON) {
    globalAdvancement {
      coursesCount
      hoursTotal
      participantsCount(ransack: $usersAllCourseRansack)
      participantsProgress(ransack: $usersAllCourseRansack) {
        finish
        inProgress
        pending
      }
      coursesDominantProgress(ransack: $usersAllCourseRansack) {
        finish
        inProgress
        pending
      }
    }
  }
`

interface GlobalProgressProps {
  applyFiltersByType: ApplyFiltersByType
  skip?: boolean
}

export const GlobalProgress: React.FC<GlobalProgressProps> = ({
  applyFiltersByType,
  skip = false,
}) => {
  const g = useMemo(
    () => applyFiltersByType(ChildFilterTypes.Participant),
    [applyFiltersByType]
  )

  const { loading, data } = useQuery<
    Pick<Query, 'globalAdvancement' | '__typename'>,
    {
      usersAllCourseRansack: { g: any }
    }
  >(GLOBAL_ADVANCEMENT, {
    variables: {
      usersAllCourseRansack: {
        g: g.filters,
      },
    },
    fetchPolicy: 'cache-and-network',
    skip,
  })

  const globalAdvancement = data?.globalAdvancement

  return (
    <GeneralProgress
      data={
        globalAdvancement
          ? {
              participantsAdvance: globalAdvancement.participantsProgress,
              coursesAdvance: globalAdvancement.coursesDominantProgress,
              participantsCount: globalAdvancement.participantsCount,
              coursesCount: globalAdvancement.coursesCount,
            }
          : undefined
      }
      loading={loading}
    />
  )
}
